export const loginEndpoint = 'auth/clients/web/login';
export const refreshEndpoint = 'auth/clients/web/refresh';
export const logoutEndpoint = 'auth/clients/web/logout';
export const getAuthenticatedUserEndpoint = 'auth/user';

export const getAllRolesEndpoint = 'roles';
export const getAllPermissionsEndpoint = 'permissions';
